import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const PaymentMethodSofortIcon = (props) => {
  const themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        width="134"
        height="88"
        viewBox="0 0 134 88"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Sofort</title>
        <path
          d="M128.429 1.39062H5.47937C2.78975 1.39062 0.609375 3.571 0.609375 6.26063V81.7406C0.609375 84.4303 2.78975 86.6106 5.47937 86.6106H128.429C131.119 86.6106 133.299 84.4303 133.299 81.7406V6.26063C133.299 3.571 131.119 1.39062 128.429 1.39062Z"
          stroke={themeColor === 'light' ? '#4D4C4C' : '#fff'}
          strokeWidth="1.22"
        />
        <path d="M110.821 63H18L24.1792 26H117L110.821 63Z" fill="#fff" />
        <path
          d="M48.5374 38.334C44.367 38.334 41.2031 41.4009 41.2031 45.0557C41.2031 48.361 43.8019 50.6673 47.337 50.6673C51.5074 50.6673 54.6506 47.5141 54.6506 43.8593C54.6712 40.5293 52.0725 38.334 48.5374 38.334ZM47.5969 47.5552C46.0046 47.5552 44.8909 46.511 44.8909 44.8994C44.8909 43.1152 46.2645 41.4173 48.2527 41.4173C49.845 41.4173 50.9588 42.5068 50.9588 44.1142C50.9794 45.919 49.5851 47.5511 47.5969 47.5511V47.5552Z"
          fill="#5C9833"
        />
        <path
          d="M73.6261 38.334C69.4558 38.334 66.3125 41.4009 66.3125 45.0557C66.3125 48.361 68.9113 50.6673 72.4464 50.6673C76.6168 50.6673 79.76 47.5141 79.76 43.8593C79.7806 40.5293 77.186 38.334 73.6261 38.334V38.334ZM72.7104 47.5552C71.1181 47.5552 70.0044 46.511 70.0044 44.8994C70.0044 43.1152 71.378 41.4173 73.3662 41.4173C74.9585 41.4173 76.0722 42.5068 76.0722 44.1142C76.0722 45.919 74.6986 47.5511 72.7104 47.5511V47.5552Z"
          fill="#5C9833"
        />
        <path
          d="M92.0266 42.226C92.0266 40.006 90.3024 38.5918 87.1591 38.5918H82.7495L80.8066 50.403H84.5191L85.1296 46.6825H85.3029L87.2664 50.403H91.5234L88.7926 46.2714C90.8221 45.5766 92.0225 44.076 92.0225 42.226H92.0266ZM86.0866 44.1829H85.5421L85.9588 41.7039H86.462C87.617 41.7039 88.2316 42.0534 88.2316 42.8139C88.2316 43.706 87.3571 44.1829 86.0908 44.1829H86.0866Z"
          fill="#5C9833"
        />
        <path
          d="M36.9459 43.3169C35.5269 42.5974 35.2217 42.4247 35.2217 42.0342C35.2217 41.5573 35.7909 41.3147 36.554 41.3147C37.4492 41.3147 38.8022 41.4216 40.1345 42.6837C40.4604 41.6601 41.009 40.7474 41.7062 39.9416C39.8293 38.8769 38.0803 38.3301 36.488 38.3301C33.3242 38.3301 31.4885 40.028 31.4885 42.0712C31.4885 43.8349 32.8209 44.7475 34.3925 45.5533C35.8115 46.2727 36.1622 46.5112 36.1622 46.947C36.1622 47.4239 35.5723 47.687 34.7885 47.687C33.4355 47.687 31.8639 46.8401 30.9234 45.9685L30.3789 49.2533C31.34 49.9481 32.7384 50.6675 34.8545 50.6675C38.1298 50.6675 39.8994 49.0149 39.8994 46.9059C39.8994 45.1669 38.765 44.2295 36.95 43.3169H36.9459Z"
          fill="#5C9833"
        />
        <path
          d="M64.4555 43.7718H60.0912L60.4418 41.7039H65.1155C65.726 40.4624 66.6665 39.3976 67.8215 38.5918H60.182C58.4783 38.5918 57.0387 39.7429 56.7995 41.3092L55.3145 50.4236H59.027L59.6375 46.703H64.0471L64.373 44.6804C64.3936 44.3556 64.4183 44.0719 64.4596 43.7677L64.4555 43.7718Z"
          fill="#5C9833"
        />
        <path
          d="M92.1135 38.5918C93.1159 39.3524 93.7305 40.4171 93.8584 41.7039H96.9562L95.5372 50.403H99.2497L100.669 41.7039H104.117L104.621 38.5918H92.1094H92.1135Z"
          fill="#5C9833"
        />
      </svg>
    </SvgIcon>
  );
};

export default PaymentMethodSofortIcon;
